import '@/plugins/bootstrapv3/js/bootstrap.js';
import '@/plugins/bootstrapv3/css/bootstrap.css';
import '@/plugins/bootstrapv3/css/bootstrap-theme.css';
import '@/plugins/font-awesome/less/font-awesome.less';
import '@/plugins/jquery-iealert/jquery.iealert.js';
import '@/plugins/jquery-iealert/jquery.iealert.css';

import { createApp } from 'vue';

import CxShell from '@/app/CxShell.vue';
import router from '@/plugins/vue-router.instance';
import gettext from '@/plugins/gettext.instance';

const rootElementId = '#cx-ui-login';

// App initialization
const app = createApp(CxShell);
app.use(router);
app.use(gettext);
app.mount(rootElementId);
